import { Card, Typography, CardContent, Box, Link } from "@mui/material";

import {
  AttachMoney,
  EmojiPeople,
  DirectionsWalk,
  TrendingUp,
} from "@mui/icons-material";
import SmallInfoCard from "./small-info-card";
import Map from "../map/map";
import { FAKE_UNITS } from "../map/unit";
import MapModal from "../map/map-modal";

export default function Dashboard(props: any) {
  return (
    <>
      <Card>
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            Welcome!
          </Typography>
          <br />
          <Typography variant="body2" color="textSecondary" component="p">
            This product is powered by{" "}
            <Link href="https://redparagon.com">Red Paragon</Link> More to
            come...
          </Typography>
          <br />
        </CardContent>
      </Card>

      <Box component="div" sx={{ display: "flex" }}>
        <Box
          component="div"
          sx={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          <SmallInfoCard
            title="Today's Money"
            info={<InfoData data="$300,000" percentage={22} />}
            icon={
              <RoundIconCard>
                <TrendingUp fontSize="medium" sx={{ color: "#f0f0f0" }} />
              </RoundIconCard>
            }
          />
          <SmallInfoCard
            title="New Clients"
            info={<InfoData data="+1,340" percentage={-3} />}
            icon={
              <RoundIconCard>
                <EmojiPeople fontSize="medium" sx={{ color: "#f0f0f0" }} />
              </RoundIconCard>
            }
          />
          <SmallInfoCard
            title="Today's Users"
            info={<InfoData data="3021" percentage={3} />}
            icon={
              <RoundIconCard>
                <DirectionsWalk fontSize="medium" sx={{ color: "#f0f0f0" }} />
              </RoundIconCard>
            }
          />
          <SmallInfoCard
            title="Sales"
            info={<InfoData data="$10,417" percentage={5} />}
            icon={
              <RoundIconCard>
                <AttachMoney fontSize="medium" sx={{ color: "#f0f0f0" }} />
              </RoundIconCard>
            }
          />
        </Box>
      </Box>
      <MapModal />
    </>
  );
}

interface TestInfoData {
  data: string;
  percentage?: number;
}

const InfoData = ({ data, percentage }: TestInfoData) => {
  const percentageInfo =
    typeof percentage === "number" ? (
      <Typography
        variant="body1"
        sx={{
          fontWeight: "bold",
          color: percentage > 0 ? "success.light" : "error.main",
          marginLeft: "3px",
        }}
      >
        {percentage > 0 ? "+" : ""}
        {percentage}%
      </Typography>
    ) : null;
  return (
    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
      <Typography variant="h5" sx={{ color: "text.primary" }}>
        {data}
      </Typography>
      {percentageInfo}
    </Box>
  );
};

const TEST_GRADIENT =
  "radial-gradient(farthest-side at -10px -10px, #ddff33, #ffaaaa)";

const RoundIconCard = (props: any) => {
  return (
    <Box
      sx={{
        borderRadius: "50%",
        background: TEST_GRADIENT,
        padding: 1,
      }}
    >
      {props.children}
    </Box>
  );
};
